import { render, staticRenderFns } from "./ItemSearch.vue?vue&type=template&id=887883aa&"
import script from "./ItemSearch.vue?vue&type=script&lang=js&"
export * from "./ItemSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentySyncs/51881/189/Woerner/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('887883aa')) {
      api.createRecord('887883aa', component.options)
    } else {
      api.reload('887883aa', component.options)
    }
    module.hot.accept("./ItemSearch.vue?vue&type=template&id=887883aa&", function () {
      api.rerender('887883aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/woerner/ItemSearch.vue"
export default component.exports